module.exports = __webpack_public_path__ + "static/media/mobile-vert.4a2f59a3.png";